<div class="donut-main-div">
    <large-card
        class="donut-large-card"
        [largeCardInteriorOptions]="largeCardOptions"
        [showTitle]="!twoDonutsTogether"
    >
    </large-card>
</div>
